import React from 'react'

const Login = ({ color }) => (
  <svg viewBox="0 0 64 64">
    <path fill={color} d="M63,32C63,14.9,49.1,1,32,1C14.9,1,1,14.9,1,32c0,9.7,4.4,18.3,11.4,24c0.1,0.1,0.2,0.2,0.3,0.2
	c5.3,4.3,12,6.8,19.4,6.8c7.3,0,14.1-2.6,19.4-6.8c0.1,0,0.1-0.1,0.2-0.1C58.5,50.3,63,41.7,63,32z M15,55.5
	c0.8-0.4,1.7-0.6,2.6-0.8c8.2-1.5,8.9-4.2,8.9-6.7v-1c0-0.3-0.1-0.5-0.3-0.7c-2-1.8-3.3-4.1-4-6.7c-0.1-0.4-0.5-0.8-1-0.8
	c-1.2,0-2-3.7-2-5c0-1.2,0.2-2,0.6-2.4c0.1-0.1,0.3-0.3,0.8-0.3c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.6,0.2-0.9
	c-1.3-4.8-1.2-9.1,0.2-10.8c0.5-0.6,1.1-0.9,2-0.9c0.2,0,0.4-0.1,0.6-0.2c5.3-3.7,11.8-4.1,15.9-1c3.4,2.6,4.2,7.3,2.2,12.8
	c-0.1,0.3-0.1,0.6,0.1,0.9c0.2,0.3,0.5,0.4,0.8,0.4c0.5,0,0.7,0.2,0.8,0.3c0.6,0.6,0.6,1.9,0.6,2.5c0,1.3-0.7,4.9-2,4.9
	c-0.5,0-0.9,0.3-1,0.8c-0.7,2.5-2,4.8-3.9,6.6c-0.2,0.2-0.3,0.5-0.3,0.7v1c0,2.4,0.7,5.2,8.9,6.7c0.9,0.2,1.8,0.5,2.6,0.9
	C44.3,58.9,38.4,61,32,61C25.6,61,19.8,58.9,15,55.5z M50.8,54.1c-1.2-0.7-2.6-1.2-4-1.5c-7.3-1.3-7.3-3.4-7.3-4.7v-0.6
	c1.9-1.8,3.2-4.1,4-6.6c3-0.9,3.2-6.7,3.2-6.9c0-0.8,0-2.7-1.2-3.8c-0.3-0.3-0.6-0.5-0.9-0.6c1.9-5.9,0.7-11-3.2-14
	c-4.7-3.6-12-3.3-18,0.8c-1.3,0.1-2.4,0.7-3.2,1.7c-1.7,2.2-2,6.4-0.8,11.5c-0.4,0.1-0.7,0.4-1,0.7c-1.2,1.2-1.2,3.1-1.2,3.9
	c0,0.1,0.3,5.9,3.2,6.8c0.8,2.6,2.2,4.9,4.1,6.7V48c0,1.3,0,3.4-7.3,4.7c-1.4,0.2-2.7,0.7-4,1.4C7,48.8,3,40.8,3,32C3,16,16,3,32,3
	c16,0,29,13,29,29C61,40.8,57,48.8,50.8,54.1z"/>
  </svg>
);

export default Login
